import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="check-in-countdown" on the "Check-in opens in …"
// banner. Ticks the remaining time down every second in "Xh Ym" form; when it
// reaches zero the window has opened, so reload to surface the check-in tools.
export default class extends Controller {
  static targets = ["countdown"]
  static values = { seconds: Number, soonLabel: String }

  connect() {
    this.remaining = this.secondsValue
    this.render()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    this.remaining -= 1
    if (this.remaining <= 0) {
      clearInterval(this.timer)
      // Window is opening — reload so scanning / manual / self check-in appear.
      window.location.reload()
      return
    }
    this.render()
  }

  render() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.format(this.remaining)
    }
  }

  // Mirror EventHelper#check_in_countdown_label: "Xh Ym" / "Ym" / "Xh", or the
  // "less than a minute" label under 60s.
  format(seconds) {
    if (seconds < 60) return this.soonLabelValue || "less than a minute"
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const parts = []
    if (hours > 0) parts.push(`${hours}h`)
    if (minutes > 0 || hours === 0) parts.push(`${minutes}m`)
    return parts.join(" ")
  }
}
